// src/components/Tasks/TaskTasksPopoverButton.jsx

import React, { useEffect, useState } from 'react'
import { Box, Button, Popover } from '@mui/material'
import AlarmIcon from '@mui/icons-material/Alarm'
import TaskTodoCards from './TaskTodoCards'
import { api } from '../../../services/Main/Api'
import { getCondoId } from '../../../services/Main/AuthStorage'

const TaskTasksPopoverButton = () => {
    const [anchorEl, setAnchorEl] = useState(null)
    const [pendingCount, setPendingCount] = useState(0)
    const open = Boolean(anchorEl)

    const fetchPendingCount = async () => {
        try {
            const response = await api.get('/tasks/pending-count/', {
                params: { condo_id: getCondoId() },
            })
            setPendingCount(response.data?.count ?? 0)
        } catch (e) {
            console.error('Erro ao buscar quantidade de tarefas pendentes', e)
            setPendingCount(0)
        }
    }

    const handleOpen = async (event) => {
        setAnchorEl(event.currentTarget)
        await fetchPendingCount()
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    useEffect(() => {
        fetchPendingCount()
    }, [])

    return (
        <Box>
            {pendingCount > 0 && <Button
                onClick={handleOpen}
                size="small"
                variant={pendingCount > 0 ? 'contained' : 'text'}
                color={pendingCount > 0 ? 'error' : 'secondary'}
                sx={{ mr: 1, fontSize: '.8rem' }}
            >
                <AlarmIcon sx={{ mr: 1, fontSize: '1.2rem',  }} /> { pendingCount}
            </Button> }

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    sx: {
                        width: 420,
                        maxHeight: 500,
                        borderRadius: 3,
                        backgroundColor: '#f7f7f7',
                        p: 0.5,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    },
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                        overflowY: 'auto',
                        pr: 1,
                        backgroundColor: '#f7f7f7',
                    }}
                >
                    <TaskTodoCards onTaskResolved={fetchPendingCount} />
                </Box>
            </Popover>
        </Box>
    )
}

export default TaskTasksPopoverButton
